//Reset ZOOM CREDENTIALS
export const RESET_ZOOM_CREDENTIALS = "RESET_ZOOM_CREDENTIALS"
export const RESET_ZOOM_CREDENTIALS_SUCCESS = "RESET_ZOOM_CREDENTIALS_SUCCESS"
export const RESET_ZOOM_CREDENTIALS_FAIL = "RESET_ZOOM_CREDENTIALS_FAIL"

//Get ZOOM AUTH URL
export const GET_ZOOM_AUTH_URL = "GET_ZOOM_AUTH_URL"
export const GET_ZOOM_AUTH_URL_SUCCESS = "GET_ZOOM_AUTH_URL_SUCCESS"
export const GET_ZOOM_AUTH_URL_FAIL = "GET_ZOOM_AUTH_URL_FAIL"
